import Languages, { Language } from "src/constants/Languages";
import Config from "src/constants/Config";
import { Grade } from "src/constants/Grades";
import { Planet } from "src/constants/Planets";

export interface VideoTranslation {
    /** The key used to load the video
     *
     *      "Landscaping.Intro.first"
     */
    key: string;
    language?: Language;
    videoUrl?: string;
    subtitleUrl?: string;
}

export default class VideoTranslations {
    public static FindByGradePlanetAndLanguage(grade: Grade, planet: Planet, languageCode: string): VideoTranslation {
        let languageCodeEnhanced = languageCode.toLowerCase();
        let key = `${(grade || { shortName: "" }).shortName}${(planet || { name: "" }).name}`;
        let videoUrl = Config.GetAzureUrl(key, "video", languageCodeEnhanced);
        let subtitleUrl = Config.GetAzureUrl(key, "subtitle", languageCodeEnhanced);

        return {
            key: key.length < 1 ? "" : key,
            language: Languages.FindByCode(languageCodeEnhanced),
            videoUrl: key.length < 1 ? "" : videoUrl,
            subtitleUrl: key.length < 1 ? "" : subtitleUrl,
        };
    }
}



// WEBPACK FOOTER //
// ./src/constants/VideoTranslations.ts